<template>
<v-main>
    <div fluid fill-height>
        <v-layout align-center justify-center>

            <v-navigation-drawer v-model="drawer" app>
                <SideMenu />
            </v-navigation-drawer>
            <v-app-bar app  v-if="showNavbar">
                <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title class="top-header-heading">
                    <h2>{{customer_name}}</h2>
                    <span>{{store_name}}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <Checkout :cart="cart"></Checkout>
                <input v-if="viewSearch" v-model="searchString" solo chips color="orange" label="Search" item-text="name" item-value="name" multiple clearable append-icon="search" placeholder="Search item" style="border-bottom:1px solid #ddd!important;font-size:14px;padding-bottom:5px;">
                <v-btn v-if="isSearch" icon @click="expandSerach()">
                    <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>notifications</v-icon>
                        </v-btn>
                    </template>
                    <span>Notifications</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <router-link class="wish-link" to="/wishlist">
                                <v-icon>mdi-heart</v-icon>
                            </router-link>
                        </v-btn>
                    </template>
                    <span>Wishlist</span>
                </v-tooltip>

            </v-app-bar>
            <slot />
            <BottomNav v-if="showNavbar" />
        </v-layout>
    </div>
</v-main>
</template>

<script>
import BottomNav from './BottomNav.vue'
import SideMenu from './SideMenu.vue'
import Checkout from '../components/Checkout.vue'
export default {
    props: ['isSearch','showNavbar'],
    components: {
        BottomNav,
        SideMenu,
        Checkout
    },

    mounted() {
        this.loadData()
        console.log("show nav bar : "+this.showNavbar)
    },
   
    data() {
        return {
            drawer: null,
            viewSearch: false,
            searchString: '',
            customer_name: '',
            store_name: '',
            cart: [],
        }
    },
    methods: {

        loadData() {
            this.store_name = localStorage.getItem("store_name")
            this.customer_name = localStorage.getItem("name")
            var cartCheck = localStorage.getItem("cart")
            if (cartCheck) {
                this.cart = localStorage.getItem("cart")
            } else {
                this.cart = []
            }
        },
        expandSerach() {
            this.viewSearch = !this.viewSearch
            if (this.viewSearch == false) {
                this.searchString = ""
            }
            // alert(this.viewSearch)
        },
     },
    watch: {
        showNavBar(){
            alert(this.showNavbar)
        },
        searchString(newVal, oldVal) {
            // this check is mandatory to prevent endless cycle
            // alert(newVal)
            if (newVal !== oldVal) this.$emit('searchText', newVal);
        }
    },
}
</script>
<style>
.wish-link{
color: #555!important;text-decoration: none;
}
</style>